import Vue from 'vue'
import Router from 'vue-router'
import routes from './setting/routes'
import store from '@/store/index'
import http from '@/http'
import cookie from '@/storage/cookies.js'
import localStorage from '@/storage/localStorage.js'
import { syncCookieToken } from "@/utils/asyncToken"


// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  // return originalPush.call(this, location).catch(err => err)
  return originalPush.call(this, location)
}

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  }
})
localStorage.clear("env")
localStorage.set("env", JSON.stringify(process.env))

let isFrist = true

// 判断是否需要登录权限 以及是否登录
router.beforeEach(async (to, from, next) => {
  // if (!cookie.cookieRead("token")) {
  //   http.memberUser().then(data=>{
  //     if(data.data.code === 0){
  //       cookie.cookieSet("token", data.data.msg)
  //       store.dispatch("setUser") //此处为处理登录以后代码，各个项目不一致，按照实际情况更改
  //     }
  //   })
  // }

  if(isFrist){
    syncCookieToken()
    isFrist = false
  }

  //路由白名单，未登录时返回首页
  let arr=['/record','/IndividualRecord']
  if(arr.includes(to.path)){
    setTimeout(()=>{
      if(!store.state.user.id){
        router.push('/')
      }
    },1000)

  }
 /* if (to.query.clientId) {
    try {
      let { data } = await http.get(`${process.env.VUE_APP_TECHNOLOGYSHARE}/tokensync/getRedisValue/${to.query.clientId}`)
      if (data.code === 200 && data.data) {
        router.push(to.name)
        cookie.cookieSet('token', data.data)
        store.dispatch('setUser')
      }
    } catch (error) {

    }
  }*/
  // eslint-disable-next-line no-undef
  if (_hmt) {
    if (to.path) {
      // eslint-disable-next-line no-undef
      _hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }

  next()
})
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
  if(to.meta.pvCount){
    setTimeout(() => {
      let pvCount=to.meta.pvCount;
      new Probe({
        event: "pvCount",
        url: `${process.env.VUE_APP_BURYINGPOINT}/v3/visitor/index`,
        source: pvCount.source,
        module: pvCount.module,
        moduleType:pvCount.moduleType?to.query[pvCount.moduleType]:''
      }).excute(window);
    }, 500);
  }

})
export default router
